const recursiveLanguageResolve = require('./recursive-language-resolve');
const responsiveimage = require('./responsiveimage');

module.exports = (banners, language) => {
  banners = recursiveLanguageResolve(JSON.parse(JSON.stringify(banners)), language);

  const now = (new Date()).getTime() / 1000;
  const authenticated = typeof window !== 'undefined'
    && window.swinger
    && window.swinger.user
    && window.swinger.user.isLoggedIn();

  return banners
    .filter((item) => {
      if (
        item.display
        && item.display.from
        && item.display.from > now
      ) {
        return false;
      }

      if (
        item.display
        && item.display.until
        && item.display.until < now
      ) {
        return false;
      }

      if (
        authenticated
        && item.audiences.indexOf('authenticated') === -1
      ) {
        return false;
      }

      if (
        !authenticated
        && item.audiences.indexOf('guests') === -1
      ) {
        return false;
      }

      return true;
    })
    .map((item) => item.content)
    .map((item) => ({
      src: item.image && item.image.src ? responsiveimage(item.image.src) : undefined,
      focalpoint: item.image ? item.image.focalpoint : undefined,
      headline: item.caption ? item.caption.headline : undefined,
      text: item.caption ? item.caption.text : undefined,
      button: item.button,
    }));
};



// WEBPACK FOOTER //
// ./src/_utilities/banners-to-carouselitems.js